module.exports = __webpack_public_path__ + "8f48c034df1ed4a007fa41266263cd31.png";